import { createSlice } from '@reduxjs/toolkit';
import { BILLING_TYPE, FIELD_CLASS, HOTEL_TYPES } from '../../utils/constants';
import { HOTEL } from '../types';

const hotelSlice = createSlice({
    name: HOTEL,
    initialState: {
        data: {},
        hotelOptions: {
            hotelName: { name: 'name', type: 'text', label: 'Hotel Name', className: FIELD_CLASS, required: true },
            address: { name: 'address', type: 'text', label: 'Address', className: FIELD_CLASS, required: true },
            careNumber: { name: 'careNumber', type: 'phone-field', label: 'Customer Care Number', className: FIELD_CLASS, required: true },
            manager: { name: 'manager', type: 'select', label: 'Staff', className: FIELD_CLASS, options: [] },
            openTime: { name: 'openTime', type: 'time', label: 'Open Time', className: FIELD_CLASS, required: true },
            closeTime: { name: 'closeTime', type: 'time', label: 'Close Time', className: FIELD_CLASS, required: true },
            hotelType: {
                name: 'hotelType',
                type: 'select',
                label: 'Hotel Type',
                className: FIELD_CLASS,
                isMulti: false,
                options: HOTEL_TYPES,
                required: true
            },
            gstNumber: { name: 'gstNumber', type: 'text', label: 'GST Number', className: FIELD_CLASS },
            upiId: { name: 'upiId', type: 'text', label: 'UPI ID', className: FIELD_CLASS },
            billingType: {
                name: 'billingType',
                type: 'select',
                label: 'Billing Type',
                className: FIELD_CLASS,
                isMulti: false,
                options: BILLING_TYPE,
                required: true
            },
            paymentGateway: {
                name: 'paymentGateway',
                type: 'checkbox',
                label: 'Turn on payment gateway services.',
                className: `col-12 my-2 gap-2 d-flex flex-row-reverse align-items-center justify-content-end`
            },
            tax: {
                name: 'tax',
                type: 'checkbox',
                label: 'Apply CGST and SGST to customer bills.',
                className: `col-12 my-2 gap-2 d-flex flex-row-reverse align-items-center justify-content-end`
            }
        },
        deleteHotelConfirm: false,
        formData: false,
        globalHotelId: null,
        hotelDetails: {},
        sorting: [],
        filtering: {},
        pagination: {
            pageIndex: 0,
            pageSize: 10
        },
        hotelType: ''
    },
    reducers: {
        setHotelOptions(state, action) {
            state.hotelOptions = action.payload;
        },
        createHotelRequest() { },
        getHotelRequest() { },
        getHotelSuccess(state, action) {
            state.data = action.payload;
        },
        updateHotelRequest() { },
        removeHotelRequest() { },
        removeHotelSuccess(state) {
            state.deleteHotelConfirm = false;
        },
        setDeleteHotelConfirm(state, action) {
            state.deleteHotelConfirm = action.payload;
        },
        setHotelFormData(state, action) {
            state.formData = action.payload;
        },
        getAssignableManagerRequest() { },
        setAssignableManagers(state, action) {
            const selectedMangers = state?.formData?.initialValues?.manager || [];
            state.hotelOptions.manager.options = [...selectedMangers, ...action.payload];
        },
        setGlobalHotelId(state, action) {
            state.globalHotelId = action.payload;
        },
        setHotelSorting(state, action) {
            state.sorting = action.payload;
        },
        setHotelFiltering(state, action) {
            state.filtering = action.payload;
        },
        setHotelPagination(state, action) {
            state.pagination = action.payload;
        },
        resetFilters(state) {
            state.filtering = {};
            state.pagination = {
                pageIndex: 0,
                pageSize: 10
            };
            state.sorting = [];
        },
        setHotelType(state, action) {
            state.hotelType = action.payload;
        }
    }
});

export const {
    setHotelOptions,
    createHotelRequest,
    getHotelRequest,
    getHotelSuccess,
    removeHotelRequest,
    removeHotelSuccess,
    updateHotelRequest,
    updateHotelSuccess,
    setDeleteHotelConfirm,
    setHotelFormData,
    getHotelManagersRequest,
    getHotelManagersSuccess,
    getAssignableManagerRequest,
    setAssignableManagers,
    setGlobalHotelId,
    setHotelSorting,
    setHotelFiltering,
    setHotelPagination,
    resetFilters,
    setHotelType
} = hotelSlice.actions;

export const hotelReducer = hotelSlice.reducer;
